import { SustainabilityDetailsSheetComponent } from './sustainability-details-sheet.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ SustainabilityDetailsComponent: SustainabilityDetailsSheetComponent });
